// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__1B36o","title":"Advt_title__vRmvm","qrsWrapper":"Advt_qrsWrapper__8yaMw","qrCode":"Advt_qrCode__L7sxZ"};